var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5473_179106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8619 20.74H14.0542C12.8966 20.7407 11.7865 21.2009 10.968 22.0195C10.1494 22.8381 9.68919 23.9481 9.68848 25.1057V103.835C9.68919 104.993 10.1494 106.103 10.968 106.921C11.7865 107.74 12.8966 108.2 14.0542 108.201H99.8619C101.02 108.2 102.13 107.74 102.948 106.921C103.767 106.103 104.227 104.993 104.228 103.835V25.1057C104.227 23.948 103.767 22.8379 102.948 22.0193C102.13 21.2007 101.02 20.7406 99.8619 20.74Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2133 80.8425H19.7041C17.2931 80.8425 15.3384 78.8878 15.3384 76.4768V6.9153C15.3384 4.50431 17.2931 2.54956 19.7041 2.54956H94.2133C96.6243 2.54956 98.5791 4.50431 98.5791 6.9153V76.4768C98.5791 78.8878 96.6243 80.8425 94.2133 80.8425Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7206 77.8585V8.29751C16.7206 5.88653 18.6753 3.93177 21.0863 3.93177H95.5956C96.4472 3.93177 97.2388 4.17927 97.9101 4.60079C97.1383 3.37005 95.7732 2.54956 94.2133 2.54956H19.7041C17.2931 2.54956 15.3384 4.50431 15.3384 6.9153V76.4768C15.3384 78.0371 16.1589 79.4017 17.3896 80.1739C16.9681 79.5022 16.7206 78.7106 16.7206 77.859V77.8585Z",
    fill: "url(#paint0_linear_5473_179106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0456 17.2471H28.8721V20.4483H85.0456V17.2471ZM85.0456 29.4706H28.8721V32.6719H85.0456V29.4706ZM85.0456 41.6968H28.8721V44.8981H85.0456V41.6968ZM85.0456 53.9203H28.8721V57.1221H85.0456V53.9203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5664 43.5876L49.682 57.7037H35.5664V43.5876Z",
    fill: "url(#paint1_linear_5473_179106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.228 58.8681V26.3897L98.5791 20.74V58.8676H104.228V58.8681Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.845 61.806L104.759 104.892C104.455 107.046 102.611 108.647 100.436 108.647H13.481C11.3058 108.647 9.46235 107.046 9.15805 104.892L0.932847 46.6724C0.561822 44.0441 2.60133 41.6958 5.25576 41.6958H32.1093C34.2845 41.6958 36.1279 43.2967 36.4322 45.4502L37.5101 53.0745C37.8144 55.2285 39.6578 56.8294 41.833 56.8294H106.523C109.177 56.8294 111.217 59.1777 110.846 61.806H110.845Z",
    fill: "url(#paint2_linear_5473_179106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2802 89.4285H24.6376C24.2833 89.4283 23.9412 89.299 23.6754 89.0647C23.4095 88.8305 23.2383 88.5073 23.1936 88.1558L22.3849 81.7524C22.3592 81.5475 22.3773 81.3395 22.4381 81.1423C22.4989 80.945 22.601 80.7629 22.7376 80.608C22.8741 80.4532 23.042 80.3291 23.2302 80.2441C23.4183 80.1591 23.6224 80.1151 23.8288 80.115H90.089C90.2954 80.1151 90.4995 80.1591 90.6876 80.2441C90.8758 80.3291 91.0437 80.4532 91.1802 80.608C91.3168 80.7629 91.4189 80.945 91.4797 81.1423C91.5405 81.3395 91.5586 81.5475 91.5329 81.7524L90.7242 88.1558C90.6795 88.5073 90.5082 88.8305 90.2424 89.0647C89.9766 89.299 89.6345 89.4283 89.2802 89.4285Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5473_179106",
    x1: 59.5187,
    y1: 44.2513,
    x2: 4.30683,
    y2: -10.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5473_179106",
    x1: 44.8925,
    y1: 59.9686,
    x2: 27.8303,
    y2: 42.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5473_179106",
    x1: 55.8891,
    y1: 41.6958,
    x2: 55.8891,
    y2: 108.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5473_179106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(0.88916 0.5979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpty);
export default __webpack_public_path__ + "static/media/icon_empty.f7fdfeac65b1b4912bc8df593ff812bb.svg";
export { ForwardRef as ReactComponent };